import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import "./featureProtectionWrapper.styles.css"
import { Modal } from "react-bootstrap"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    premium: boolean
    message: string
    onClose: () => void
    goToMyAccount: () => void
    intl: Intl
}


const FeatureProtectionWrapperModal = (props: OwnProps) => {
    return <Modal
        show={true}
        onHide={props.onClose}
        {...props}
        scrollable={true}
        size={"lg"}
        backdrop="static">
        <Modal.Header closeButton>
            <h4 className={""}>
                {props.premium ?
                    <FormattedMessage
                        id="common.premium.cta_modal.title"
                        defaultMessage="Premium feature"

                    /> :
                    <FormattedMessage
                        id="common.premium.cta_modal.info"
                        defaultMessage="Upgrade your plan"
                    />}
            </h4>
        </Modal.Header>

        <Modal.Body className="p-4">
            {props.message ?? ""}
            {props.premium &&
                <div>
                    <p>
                        <FormattedMessage
                            id="common.premium.cta_modal.enable_feature_message"
                            defaultMessage="This feature is available on the next plan.
                            You can upgrade your plan from your account setting."
                        />
                    </p>
                </div>
            }
            <hr />
            <p className={"text-center"}>
                <button onClick={() => props.goToMyAccount()} className="btn btn-primary">
                    <FormattedMessage
                        id="common.premium.cta_modal.go_to_my_account"
                        defaultMessage="Go to my account"
                    />
                </button>
            </p>
        </Modal.Body>
    </Modal>
}


export default injectIntl(FeatureProtectionWrapperModal)


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/featureProtectionWrapperModal.component.tsx